import { render, staticRenderFns } from "./AuditorsSection.vue?vue&type=template&id=f850e2f8&scoped=true"
import script from "./AuditorsSection.vue?vue&type=script&lang=ts"
export * from "./AuditorsSection.vue?vue&type=script&lang=ts"
import style0 from "./AuditorsSection.vue?vue&type=style&index=0&id=f850e2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f850e2f8",
  null
  
)

export default component.exports